<template>
  <div style="display: inline-block">
    <div class="cloum">
      <!--收件箱-->
      <template v-if="applyType === 'signList'">
<!--        已拒签-->
        <template v-if="rowData[fields.signStatus] === 2">
         <span
           @click="refuseResonVisible = true"
           class="color-success"
         >查看拒签原因</span>
        </template>
        <!--未完成-->
        <template v-if="rowData[fields.signStatus] === 0">
          <!--待我签-->
          <span
            @click="
              toSign(
                rowData[fields.signNo],
                rowData.approveId,
                rowData.multiFile,
                rowData.aiCorpUserIdFlag
              )
            "
            v-if="rowData.selfSign === 1"
            class="color-success"
          >签署</span>
          <!--待ta签-->
          <template v-else>
            <span
              v-if="rowData.isReminderSign === 1"
              class="color-success"
              @click="reminderSign(rowData)"
            >再催</span>
            <span v-else class="color-success" @click="reminderSign(rowData)">催签</span>
          </template>
          <span v-if="selfAuthFn(rowData)" @click="batchCancel(rowData)" class="color-success">撤销</span>
          <span
            v-if="
              selfAuthFn(rowData) &&
              rowData.applySignCreateType !== 0 &&
              rowData.createType !== 0
            "
            @click="getNoSingInfo(rowData.applyNo)"
            class="color-success"
          >链接</span>
        </template>
        <template v-else-if="rowData[fields.signStatus] === 1">
          <certiServicepopover
            class="color-success"
            listType="userList"
            :param="{
              signNo: rowData[this.fields.signNo] || '',
              applyNo: rowData.applyNo || '',
            }"
            :newUrl="0"
          >出证</certiServicepopover>
          <!-- 证书去往新页面 newUrl 0 旧业面 1 新页面 -->
          <certiServicepopover
            listType="userList"
            :newUrl="1"
            :param="{
              signNo: rowData[this.fields.signNo] || '',
              applyNo: rowData.applyNo || '',
            }"
          >
            <el-badge
              :is-dot="rowData.hasCert == 1"
              class="color-success"
              style="float: right; top: 5px"
            >证书</el-badge>
          </certiServicepopover>
        </template>
        <template v-else-if="rowData[fields.signStatus] === -6">
          <span></span>
        </template>
      </template>

      <!--发件箱-->
      <template v-else-if="applyType === 'applyList'">
        <!--        已拒签-->
        <template v-if="rowData[fields.signStatus] === 2">
         <span
           @click="refuseResonVisible = true"
           class="color-success"
         >查看拒签原因</span>
        </template>
        <!--未完成-->
        <template v-if="rowData[fields.signStatus] === 0">
          <template v-if="rowData.selfSign === 1">
            <span
              @click="
                toSign(
                  rowData.signNo,
                  rowData.approveId,
                  rowData.multiFile,
                  rowData.aiCorpUserIdFlag
                )
              "
              class="color-success"
            >签署</span>
            <span
              v-if="fileSelfAuthFn(rowData)"
              @click="batchCancel(rowData)"
              class="color-success"
            >撤销</span>
          </template>
          <template v-else>
            <span
              v-if="fileSelfAuthFn(rowData)"
              @click="batchCancel(rowData)"
              class="color-success"
            >撤销</span>
            <span
              v-if="rowData.isReminderSign === 1 && fileSelfAuthFn(rowData)"
              class="color-success"
              @click="reminderSign(rowData)"
            >再催</span>
            <span
              v-else-if="
                rowData.isReminderSign === 0 && fileSelfAuthFn(rowData)
              "
              class="color-success"
              @click="reminderSign(rowData)"
            >催签</span>
            <span
              v-if="
                rowData.showQrCode === 1 &&
                fileSelfAuthFn(rowData) &&
                rowData.applySignCreateType !== 0 &&
                rowData.createType !== 0
              "
              @click="getNoSingInfo(rowData.applyNo)"
              class="color-success"
            >链接</span>
          </template>
        </template>
        <!--已结束-->
        <template v-else-if="rowData[fields.signStatus] === -6">
          <span></span>
        </template>
      </template>
    </div>

    <!--用户扫码签选择用户 弹窗-->
    <el-dialog
      title="获取签署链接"
      :visible.sync="visibleNoSignList"
      modal-append-to-body
      append-to-body
      :close-on-click-modal="false"
      :show-close="true"
      width="550px"
      custom-class="my-dialog"
    >
      <div class="flex">
        <el-select
          :value="noSign.signNo"
          @input="
            (val) => {
              dselect(val);
            }
          "
          placeholder="选择待签署方"
        >
          <el-option
            class="my-dialog-select"
            v-for="item in noSign.data"
            :key="item.signNo"
            :label="item.fullName"
            :value="item.signNo"
          ></el-option>
        </el-select>
        <!--        <el-button class="a-btn ml10" @click="getNoSignUrl(noSign.signNo)">获取ta的二维码和链接</el-button>-->
      </div>
      <div class="flex" style="margin: 15px auto">将下方二维码或链接复制发送给对方，即可进行签署。</div>
      <div class="flex dashed">
        <div class="box">
          <div class="qrcode">
            <qrcode v-if="showQy" :value="noSign.url" :size="140" leave="H" key="evidence" />
            <span v-else class="ne-text">请先选择签署方</span>
          </div>
          <el-button class="b-btn" :disabled="!showQy" @click="saveQr">保存二维码</el-button>
        </div>
        <div class="box">
          <div style="padding: 10px; box-sizing: border-box">
            <template v-if="showQy">{{ noSign.url }}</template>
            <span v-else class="ne-text">请先选择签署方</span>
          </div>
          <el-button
            class="b-btn"
            :disabled="!showQy"
            id="tag-copy"
            :data-clipboard-text="noSign.url"
            @click="copyText($event)"
          >复制签署链接</el-button>
        </div>
      </div>
    </el-dialog>
<!--    refuseResonVisible-->
    <el-dialog
      title="拒签原因"
      :visible.sync="refuseResonVisible"
      width="30%">
      <div>
        <p>签约方：{{rowData.signInfoVOS[0].signatoryFullName}}</p>
        <div>拒签原因：{{rowData.signInfoVOS[0].refuseReason}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="refuseResonVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import InsureController from "@/assets/js/http-serve/insuranceController";
import SignContract from "@/assets/js/http-serve/signInfoController";
import {
  applyViewUrl,
  ApiMethods,
  noSignList,
  noSignUrl,
  configUrl
} from "@/assets/js/http-serve/http-methods";
import Qrcode from "qrcode.vue";
import Clipboard from "clipboard";
import CertiServicepopover from "./certiServicepopover";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

export default {
  name: "handles",
  components: { Qrcode, CertiServicepopover },
  data () {
    return {
      // 合同没有签署的签署方信息和url
      noSign: { data: null, url: "", name: "", signNo: "" },
      visibleNoSignList: false,
      refuseResonVisible: false,
    };
  },
  props: {
    rowData: {
      type: Object
    },
    // 发件箱还是收件箱，用于区分操作按钮的显示类型 'signList': 收件箱  'applyList': 发件箱
    applyType: {
      type: String
    },
    // 字段名（必须传递过来，不能只通过applyType判断。因为文件归类所用的字段全部是发起的字段）
    // 'applySignStatus': 收件箱字段   'signStatus': 发件箱字段
    fieldType: {
      type: String
    }
  },
  computed: {
    fields () {
      if (this.fieldType === "applySignStatus") {
        // 收件箱字段
        return {
          signStatus: "applySignStatus",
          signNo: "signInfoNo"
        };
      } else if (this.fieldType === "signStatus") {
        // 发件箱字段
        return {
          signStatus: "signStatus",
          signNo: "signNo"
        };
      }
      return {};
    },
    showQy () {
      return !!this.noSign.url;
    }
  },
  methods: {
    selfAuthFn (row) {
      return (
        row.selfCreated === 1 ||
        (this.$store.getters.authUser.userType === 1 &&
          row.ebqUserId === this.$store.getters.authUser.userId)
      );
    },
    fileSelfAuthFn (row) {
      return (
        row.myCreate === 1 ||
        (this.$store.getters.authUser.userType === 1 &&
          row.ebqUserId === this.$store.getters.authUser.userId)
      );
    },
    async openCSDialog (rowData) {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: rowData[this.fields.signNo] || "",
        applyNo: rowData.applyNo || ""
      };
      let viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        this.$emit("setCSDialogData", {
          cSDialogVisible: true,
          cSDialogData: certiRes.data
        });
      } else {
        _this.$message.error(certiRes.description);
      }
    },
    /** 批量签逻辑处理 */
    batchSignInfo(signNo, approveId){
      ApiMethods.CertiController.batchSignUrl({signNo}).then(res=>{
        if(!res.success) return this.$message.error(res.description || '获取批量签署地址失败')
        const {ts,mid:mId,bsNo,iden,sign} =res.data;
      let router = this.$router.resolve({
          path: '/derong/signInfo/viewDetail',
          query: {ts,mId,bsNo,iden,sign,applySignDealType:this.rowData.applySignDealType}
        });
        let href = window.location.origin + router.href;
        // 如果是钉钉环境就走 location 不要 window.open
        isInDingTalk ? location.href = href : window.open(href,'_blank')
      })
    },
    // 前往签署
    toSign (signNo, approveId, multiFile, aiCorpUserIdFlag) {
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((this.rowData.applyNo && this.rowData.applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      // 如果是批量签，走批量签的逻辑
        if ([17,20].includes(this.rowData.applySignDealType)) return this.batchSignInfo(signNo, approveId);
      this.loading = this.$loading({ lock: true });
      SignContract.postSignUrl(signNo)
        .then(res => {
          this.loading.close();
          const { data } = res
          if (!res.success) return this.$message.error(res.description)
          data.approveId = approveId;
          if (isInDingTalk) {
            multiFile
              ? this.$router.push({
                path: "/initiation/viewDetail",
                query: data
              })
              : this.$router.push({
                path: "/signInfo/viewDetail",
                query: data
              });
          } else {
            let router = multiFile
              ? this.$router.resolve({
                path: "/initiation/viewDetail",
                query: data
              })
              : this.$router.resolve({
                path: "/signInfo/viewDetail",
                query: data
              });
            let href = window.location.origin + router.href;
            const _path = aiCorpUserIdFlag
              ? href + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
              : href;
            isInDingTalk ? location.href=_path : window.open(_path, "_blank")
          }

          // 设置token
          localStorage.setItem("JZQ_SIGN_TOKEN_KEY", data.tokenKey);
          localStorage.setItem("JZQ_SIGN_TOKEN", data.token);
        })
        .catch(err => {
          this.loading.close();
          this.$confirm(err.description, "系统提示", {
            confirmButtonText: "确定",
            type: "warning",
            customClass: "handle-message"
          }).then(() => { });
        });
    },
    // 前往合同详情
    toApplyDetail ({ applyNo, signNo, multiFile, aiCorpUserIdFlag }) {
      var param = { signNo: signNo, applyNo: applyNo, multiFile: multiFile };
      this.loading = this.$loading({ lock: true });
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();
      applyViewUrl(param)
        .then(url => {
          this.loading.close();
          let href = aiCorpUserIdFlag
            ? url + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
            : url;
          isInDingTalk ? location.href = href : newWindow.location.href = href
        })
        .catch(err => {
          this.loading.close();
          if (!isInDingTalk) newWindow.close();
          this.$message.error(err.description || "无法查看该合同");
          console.error("toApplyDetail: " + JSON.stringify(err));
        });
    },
    // 催签
    reminderSign (sign) {
      var param = {
        signInfoId: sign.signInfoId || null,
        applyId: sign.applyId || null,
        returnURL: window.location.href
      };
      ApiMethods.SendSms4SignController.reminderSign(param)
        .then(res => {
          // data参数：{cashierUrl:'', money: '', orderNumber: '', point: ''}
          var data = res.data;
          if (!data.needPay) {
            return this.$message.success("催签成功");
          }
          if (res.success || res.success === "true") {
            if (res.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `<div style="font-weight: bold;color: #606266;font-size: 18px;text-align: center;border: 1px dashed #FCE2E2;padding-bottom: 5px ">
                            <img src="/images/icon_signed.png" style="height: 80px">
                            <p style="margin-top: 10px">需花费：
                            <span style="color: #Ec1C1C">${data.point}积分/次</span></p>
                            <p style="margin-top: 10px;padding: 0 10px;font-weight: 400;font-size: 14px;text-align: start">
                            <i class="el-icon-info" style="margin-right: 5px"></i>
                            确定后，未签署的签约方将收到催签短信通知，此通知72小时有效。</p></div>`,
                "温馨提示",
                {
                  showConfirmButton: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  customClass: "handle-message"
                  // type: 'info',
                }
              ).then(() => {
                ApiMethods.SendSms4SignController.reminderSign(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) return this.$message.success("催签成功");
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    },
    // 获取合同没有签署的签署方信息
    getNoSingInfo (applyNo) {
      if (!applyNo) return;
      noSignList({ applyNo: applyNo }).then(({ data }) => {
        this.noSign.data = data || null;
        this.visibleNoSignList = true;
      });
    },
    getNoSignUrl (signNo) {
      if (!signNo) return;
      noSignUrl(signNo).then(({ data }) => {
        if (data) {
          this.noSign.url = data;
        }
      });
    },
    dselect (val) {
      this.noSign.signNo = val;
      this.noSign.data.map(item => {
        if (item.signNo == val) {
          this.noSign.name = item.fullName;
        }
      });
      this.getNoSignUrl(val);
    },
    // 复制
    copyText () {
      const clipboard = new Clipboard("#tag-copy");
      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    // 下载二维码
    saveQr () {
      let canvas = document.querySelector(".qrcode canvas");
      let imgUrlBase64 = canvas.toDataURL("image/png");
      if (window.navigator.msSaveOrOpenBlob) {
        // ie
        let bstr = atob(imgUrlBase64.split(",")[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "二维码" + "." + "png");
      } else {
        let oA = document.createElement("a");
        oA.download = "二维码.png";
        oA.href = imgUrlBase64;
        document.body.appendChild(oA);
        oA.click();
        oA.remove();
      }
    },
    // 证书
    gotoTestify (item) {
      let param = {
        signNo: item[this.fields.signNo] || "",
        applyNo: item.applyNo || ""
      };
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();
      ApiMethods.UserApplySignController.viewUrl(param).then(viewResult => {
        if (!viewResult.success) {
          if (!isInDingTalk) newWindow.close();
          return this.$message.error(
            viewResult.description || "初始化数据失败1"
          );
        }
        ApiMethods.ApplySignController.certi(viewResult.data).then(
          redirectResult => {
            if (redirectResult.success) {
              let { href } = this.$router.resolve({
                path: "/certi/certiPage",
                query: redirectResult.data
              });
              isInDingTalk ? location.href = location.origin + href : newWindow.location.href = window.location.origin + href;
            } else {
              if (!isInDingTalk) newWindow.close();
              this.$message.error(redirectResult.description);
            }
          }
        );
      });
    },
    // 撤销合同
    batchCancel: function (item) {
      const batchText = item ? "合同撤销后，原合同将无法再签署，确定撤销？" : "确定删除";
      let ids = [],
        dels = item ? [item] : [];
      for (let i = 0; i < dels.length; i++) {
        ids.push(dels[i].applyId);
      }
      if (ids.length < 1) {
        return this.$alert("你还未选择要操作的数据", "系统提示");
      }
      this.$confirm(batchText, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "handle-message"
      })
        .then(() => {
          ApiMethods.UserApplySignController.batchCancel({
            applyIds: ids.join(",")
          }).then(result => {
            const { notMeSign } = this.$route.query;
            const msgText =
              notMeSign == 1 ? "撤销成功" : "撤销成功，请前往已结束列表查看";
            if (result.success) {
              item
                ? this.$message.success(msgText)
                : this.$message.success(result.description || "操作成功");
              this.$emit("resetList");
            } else {
              this.$message.error(result.description || this.$tip);
            }
          });
        })
        .catch(() => { });
    }
  }
};
</script>
<style lang="less" scoped>
.handle-message {
  .el-message-box__header {
    background: #eeeeee !important;
  }
  .el-message-box__btns {
    text-align: center;
  }

  .el-button--primary {
    width: 180px;
  }
}
</style>
<style lang="less" scoped>
.cloum {
  display: flex;
  flex-direction: column;
}
.color-success,
.color-danger {
  cursor: pointer;
  margin-right: 8px;
  color: #290202;
  font-weight: bold;

  &:hover {
    color: #ec1c1c;
  }
}

/deep/ .my-dialog {
  .el-dialog__header {
    padding: 0 20px;
    line-height: 40px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 0px 6px rgba(243, 203, 203, 0.3);
    opacity: 1;
    border-radius: 2px 2px 0px 0px;

    .el-dialog__title {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }

    .el-icon {
      color: #8c8c8c;
    }

    .el-dialog__headerbtn {
      top: 8px;
    }
  }

  .el-dialog__body {
    box-shadow: 3px 0px 6px rgba(243, 203, 203, 0.3);
    background: rgba(255, 255, 255, 1);
    padding: 40px 20px 30px 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 440px;
    margin: 0 auto;

    .el-select {
      flex: auto;
      .el-input__inner {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        padding: 0 20px 0 10px;
        /*border:1px solid rgba(216,216,216,1);*/
        opacity: 1;
        border-radius: 2px;
      }
      .el-input__suffix {
        right: 1px;
        top: 50%;
        margin-top: -13px;
      }
      .el-input__suffix-inner {
        background-color: #ffe9e9;
      }
      .el-input__icon {
        width: 20px;
        line-height: 26px;
        color: #ec1c1c;
      }
    }
  }

  .dashed {
    border: 1px dashed rgba(236, 28, 28, 0.3);
    border-radius: 4px;
    /*margin-top:30px;*/
    padding: 20px 0;
    justify-content: space-around;

    .box {
      text-align: center;
      > div {
        font-size: 14px;
        background: rgba(248, 248, 248, 1);
        opacity: 1;
        border-radius: 2px;
        width: 150px;
        height: 150px;
        overflow-y: auto;
        margin-bottom: 10px;
        text-align: left;
        position: relative;
      }

      .qrcode /deep/ canvas {
        position: absolute;
        /*width: 140px !important;*/
        /*height:140px !important;*/
        left: 50%;
        top: 50%;
        margin-left: -70px;
        margin-top: -70px;
      }
    }
  }
}

.my-dialog-select {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  padding: 0 10px;

  &.el-select-dropdown__item.hover,
  &.el-select-dropdown__item:hover {
    background-color: #ffe6e6;
    color: #ec1c1c;
  }
}

.ml10 {
  margin-left: 10px;
}

.a-btn {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
  text-decoration: none;
  height: 30px;
  min-width: 130px;
  padding: 0;
  color: #ec1c1c;
  border: 1px solid rgba(236, 28, 28, 1);
  opacity: 1;
  border-radius: 4px;

  &:focus {
    color: #ec1c1c;
    border: 1px solid rgba(236, 28, 28, 1);
  }

  &:hover {
    background-color: #ec1c1c;
    color: rgba(255, 255, 255, 1);
  }

  &.is-disabled {
    background-color: #cccccc;
    color: rgba(255, 255, 255, 1);
    border: transparent;
  }
}

.b-btn {
  .a-btn();
  background-color: #ec1c1c;
  color: rgba(255, 255, 255, 1);
  &:hover {
    opacity: 0.7;
  }
  &:focus {
    background-color: #ec1c1c;
    color: rgba(255, 255, 255, 1);
  }
}

.ne-text {
  top: 20px;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// components/apply-list/handles.vue